import React from "react";
import TabLayout from "../../helpers/TabLayout";
import { Stack, styled } from "@mui/material";
import SearchForm from "./SearchForm";
import { useLoaderData } from "react-router-dom";
import { userEmailList } from "../../../api/useremail";
import { userList } from "../../../api/user";
import SearchTable from "./SearchTable";
import { testSessionLoader } from "../../../loaders/helpers";
import SearchNoResults from "./SearchNoResults";

const StyledSearchContainer = styled(Stack)`
  justify-content: center;
  align-items: center;
`;

const searchTabLoader = async (params) => {
  await testSessionLoader(params);
  const url = new URL(params.request.url);
  const searchQuery = url.searchParams.get("search") || null;
  if (!searchQuery) return null;

  const emailsListRes = await userEmailList(-1);
  const userListRes = await userList(-1);
  let filteredEmails = emailsListRes.data.filter(email =>
    email.email.toLowerCase().startsWith(searchQuery.toLowerCase()),
  );

  let filteredUsers = userListRes.data.filter(user =>
    user.firstName.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
    user.lastName.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
    filteredEmails.some(email =>
      user.userEmailEntityId === email.userEmailEntityId,
    ),
  );

  filteredUsers = filteredUsers.map(user => {
    const matchingEmail = emailsListRes.data.find(email =>
      user.userEmailEntityId === email.userEmailEntityId,
    );
    return {
      ...user,
      email: matchingEmail ? matchingEmail.email : null,
    };
  });

  filteredEmails = filteredEmails.map(email => {
    const matchingUser = userListRes.data.find(user =>
      user.userEntityId === email.userEntityId,
    );
    if (matchingUser) {
      return {
        ...matchingUser,
        ...email,
      };
    }
  });

  filteredUsers = [...filteredUsers, ...filteredEmails];

  filteredUsers = filteredUsers.reduce((filteredList, current) => {
    if (!filteredList.some(
      user => user.userEmailEntityId === current.userEmailEntityId)) {
      filteredList.push(current);
    }
    return filteredList;
  }, []);

  filteredUsers.sort((user1, user2) =>
    user1.lastName.toLowerCase().localeCompare(user2.lastName.toLowerCase()) ||
    user1.firstName.toLowerCase().localeCompare(user2.firstName.toLowerCase()),
  );

  return { searchQuery, usersList: filteredUsers };
};

const SearchTab = () => {
  const loaderData = useLoaderData();

  return (
    <TabLayout
      headerLabel="Search"
      skeletonLines={16}
    >
      <StyledSearchContainer>
        <SearchForm defaultSearch={loaderData?.searchQuery}/>
        {!!loaderData?.usersList?.length ? (
          <SearchTable usersList={loaderData.usersList}/>
        ) : (
          <>
            {loaderData && <SearchNoResults/>}
          </>
        )}
      </StyledSearchContainer>
    </TabLayout>
  );
};

export { searchTabLoader };
export default SearchTab;